import { render } from "./AposLoadingBlock.vue?vue&type=template&id=1b8a30e2&scoped=true"
import script from "./AposLoadingBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./AposLoadingBlock.vue?vue&type=script&setup=true&lang=js"

import "./AposLoadingBlock.vue?vue&type=style&index=0&id=1b8a30e2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8a30e2"],['__file',"ui/ui/apos/components/AposLoadingBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b8a30e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b8a30e2', __exports__)) {
    api.reload('1b8a30e2', __exports__)
  }
  
  module.hot.accept("./AposLoadingBlock.vue?vue&type=template&id=1b8a30e2&scoped=true", () => {
    api.rerender('1b8a30e2', render)
  })

}


export default __exports__